import { Col, Form, Row } from 'antd';

import FormCheckBox from '../../../../../components/Inputs/FormCheckBox';
import FormInput from '../../../../../components/Inputs/FormInput';
import FormSelectBox from '../../../../../components/Inputs/FormSelectBox';

const HalBiddingSearchableLogDetails = ({ providersDetails, carrierStatuses, name, isStatusEnabled = true }) => {
  return (
    <Form.Item>
      <div className="paper-container border-muted mb-15 ant-collapse-header">
        <div className="py-10">
          <Row
            gutter={10}
            className="flex-nowrap px-15"
            justify="start"
            align="start"
            data-testid="hal-bidding-searchable-log-details"
          >
            <Col sm={1}>
              <FormCheckBox
                name={[name, 'isChecked']}
                className="m-0"
                checkBoxClass="normal-checkbox"
                checked={providersDetails?.isChecked}
              />
            </Col>

            <Col sm={5}>
              <p className="m-0 fw-400 f-12 color-label"> Transportation Provider </p>
              <p className="mt-1 fw-500 f-13 color-dark"> {providersDetails?.carrierName || ''}</p>
            </Col>
            <Col sm={3}>
              <p className="m-0 fw-400 f-12 color-label">SCAC </p>
              <p className="mt-1 fw-500 f-13 color-dark">{providersDetails?.carrierScacCode || ''}</p>
            </Col>

            <Col sm={3}>
              <p className="m-0 fw-400 f-12 color-label">Short Name</p>
              <p className="mt-1 fw-500 f-13 color-dark">{providersDetails?.carrierShortName || ''}</p>
            </Col>
            {isStatusEnabled && (
              <Col sm={3}>
                <FormSelectBox
                  className="m-0 fw-400 f-12 color-label"
                  options={carrierStatuses}
                  label="Status"
                  placeholder="Status"
                  name={[name, 'status']}
                  dataTestId="select-testName"
                  rules={[
                    {
                      message: 'Please select a status',
                      required: Boolean(providersDetails?.isChecked),
                    },
                  ]}
                />
              </Col>
            )}
            <Col sm={7}>
              <FormInput
                className="m-0 fw-400 f-12 color-label"
                label="Email"
                editMode
                name={[name, 'email']}
                rules={[
                  {
                    message: 'An email address is required',
                    required: Boolean(providersDetails?.isChecked),
                  },
                ]}
              />
            </Col>
          </Row>
        </div>
      </div>
    </Form.Item>
  );
};

export default HalBiddingSearchableLogDetails;
